import "./SideDrawer.css";
import { Close } from "@mui/icons-material";
import Button from "../Button/Button";
import { Drawer } from "@mui/material";

export function SideDrawer({ children, className, ...rest }) {
  return (
    <Drawer
      {...rest}
      className={["SideDrawer", className].filter(Boolean).join(" ")}
    >
      {children}
    </Drawer>
  );
}

export function SideDrawerHeader({ title, subtitle, onClose }) {
  return (
    <div className="SideDrawer-header">
      <div className="SideDrawer-header-title">
        {title && <span className="SideDrawer-header-title-text">{title}</span>}
        <div style={!title ? { marginLeft: "auto" } : {}}>
          <Button
            className="SideDrawer-header-title-button"
            icon={<Close />}
            onClick={onClose}
          />
        </div>
      </div>
      {subtitle && <div className="SideDrawer-header-subtitle">{subtitle}</div>}
    </div>
  );
}

export function SideDrawerContent({ children }) {
  return <div>{children}</div>;
}
